module.exports = __webpack_public_path__ + "img/cross_red.2f5d3af6.svg";